import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroBanner } from './components/HeroBanner';
import { BookOnline } from './components/BookOnline';
import { OurServices } from './components/OurServices';
import { HousekeepingRevolution } from './components/HousekeepingRevolution';
import { FAQ } from './components/FAQ';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
import { SEOHead } from './components/SEOHead';
import { OrganizationSchema, WebsiteSchema } from './components/StructuredData';
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy').then(m => ({
  default: m.PrivacyPolicy
})));
const FAQPage = lazy(() => import('./pages/FAQPage').then(m => ({
  default: m.FAQPage
})));
const AboutUs = lazy(() => import('./pages/AboutUs').then(m => ({
  default: m.AboutUs
})));
const ContactUs = lazy(() => import('./pages/ContactUs').then(m => ({
  default: m.ContactUs
})));
const BasicHomeCleaning = lazy(() => import('./pages/BasicHomeCleaning').then(m => ({
  default: m.BasicHomeCleaning
})));
const CommercialCleaning = lazy(() => import('./pages/CommercialCleaning').then(m => ({
  default: m.CommercialCleaning
})));
const SpringDeepCleaning = lazy(() => import('./pages/SpringDeepCleaning').then(m => ({
  default: m.SpringDeepCleaning
})));
function HomePage() {
  return <div className="min-h-screen w-full font-sans bg-white" data-id="element-0">
      <SEOHead title="Smith & Jengs Cleaning Services | Professional Cleaning in Bicester & Oxfordshire" description="Professional residential and commercial cleaning services in Bicester and Oxfordshire. Eco-friendly products, vetted cleaners, online booking, and 100% satisfaction guarantee." canonical="https://smithandjengs.com/" data-id="element-1" />
      <Navbar data-id="element-2" />
      <HeroBanner data-id="element-3" />
      <BookOnline data-id="element-4" />
      <OurServices data-id="element-5" />
      <HousekeepingRevolution data-id="element-6" />
      <FAQ data-id="element-7" />
      <WhyChooseUs data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}
export function App() {
  return <Router data-id="element-10">
      <div className="relative" data-id="element-11">
        <OrganizationSchema data-id="element-12" />
        <WebsiteSchema data-id="element-13" />
        <Suspense fallback={<div className="min-h-screen w-full flex items-center justify-center bg-white" data-id="element-15">
              <div className="w-10 h-10 border-4 border-[#1a2744] border-t-[#e91e8c] rounded-full animate-spin" data-id="element-16" />
            </div>} data-id="element-14">
          <Routes data-id="element-17">
            <Route path="/" element={<HomePage data-id="element-19" />} data-id="element-18" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-21" />} data-id="element-20" />
            <Route path="/faq" element={<FAQPage data-id="element-23" />} data-id="element-22" />
            <Route path="/about-us" element={<AboutUs data-id="element-25" />} data-id="element-24" />
            <Route path="/contact-us" element={<ContactUs data-id="element-27" />} data-id="element-26" />
            <Route path="/basic-home-cleaning" element={<BasicHomeCleaning data-id="element-29" />} data-id="element-28" />
            <Route path="/commercial-cleaning" element={<CommercialCleaning data-id="element-31" />} data-id="element-30" />
            <Route path="/spring-deep-cleaning" element={<SpringDeepCleaning data-id="element-33" />} data-id="element-32" />
          </Routes>
        </Suspense>
        <CookieConsent data-id="element-34" />
      </div>
    </Router>;
}